import { useEffect, useState } from "react";
import axios from "axios";
const StudentProfile = () => {

    const [student, setStudent] = useState([]);
    useEffect(() => {
        axios.get('/api/student/student-info', {
        withCredentials: true
        })
        .then((response) => setStudent(response.data))
        .catch((error) => console.error('Error fetching student data:', error));
    }, []);

    const fileUrl = `${process.env.REACT_APP_BASE_SITE_URL}/uploads/`;
    return (
        <div className="row gy-44">
            <div className="col-xxl-6">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                    <div className="card-header py-16 px-10 bg-base border border-end-0 border-start-0 border-top-0">
                        <h3 className="mb-0">Student Profile</h3>
                    </div>
                    <div className="card-body p-10 pt-10">
                        <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-grey h-100">
                            <img
                                src={`${fileUrl}/user-grid-bg1.png`}
                                alt=""
                                className="w-100 object-fit-cover"
                            />
                            <div className="pb-24 ms-16 mb-24 me-16 mt--100">
                                <div className="text-center border border-top-0 border-start-0 border-end-0">
                                    <img
                                        src={`${fileUrl}${student?.photo}`}
                                        alt=""
                                        className="border br-black border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover"
                                    />
                                    <h6 className="mb-0 mt-16">{student?.student_first_name} {student?.student_last_name}</h6>
                                    <span className="text-secondary-light mb-16">{
                                    //student?.email
                                    }</span>
                                </div>
                                <div className="mt-24">
                                    <h6 className="text-xl mb-16">Personal Info</h6>
                                    <ul>
                                        <li className="d-flex align-items-center gap-1 mb-12">
                                            <span className="w-30 text-md fw-semibold text-primary-light">Register ID</span>
                                            <span className="w-70 text-secondary-light fw-medium">: {student?.regi_id} {student?.student_last_name}</span>
                                        </li>
                                        <li className="d-flex align-items-center gap-1 mb-12">
                                            <span className="w-30 text-md fw-semibold text-primary-light">RFID</span>
                                            <span className="w-70 text-secondary-light fw-medium">: {student?.rfid} {student?.student_last_name}</span>
                                        </li>
                                        <li className="d-flex align-items-center gap-1 mb-12">
                                            <span className="w-30 text-md fw-semibold text-primary-light">Class</span>
                                            <span className="w-70 text-secondary-light fw-medium">: {student?.class_name}</span>
                                        </li>
                                        <li className="d-flex align-items-center gap-1 mb-12">
                                            <span className="w-30 text-md fw-semibold text-primary-light">Div</span>
                                            <span className="w-70 text-secondary-light fw-medium">: {student?.division_name}</span>
                                        </li>
                                        <li className="d-flex align-items-center gap-1 mb-12">
                                            <span className="w-30 text-md fw-semibold text-primary-light">Roll No</span>
                                            <span className="w-70 text-secondary-light fw-medium">: {student?.roll_no}</span>
                                        </li>
                                        <li className="d-flex align-items-center gap-1 mb-12">
                                            <span className="w-30 text-md fw-semibold text-primary-light">Email</span>
                                            <span className="w-70 text-secondary-light fw-medium">: {student?.email}</span>
                                        </li>
                                        <li className="d-flex align-items-center gap-1 mb-12">
                                            <span className="w-30 text-md fw-semibold text-primary-light">Phone Number</span>
                                            <span className="w-70 text-secondary-light fw-medium">: {student?.mobile_no}</span>
                                        </li>
                                        <li className="d-flex align-items-center gap-1 mb-12">
                                            <span className="w-30 text-md fw-semibold text-primary-light">Blood Group</span>
                                            <span className="w-70 text-secondary-light fw-medium"> : {student?.blood_group} </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-1">
                                            <span className="w-30 text-md fw-semibold text-primary-light">Address</span>
                                            <span className="w-70 text-secondary-light fw-medium">
                                                : {student?.address}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentProfile;